<template>
    <section class="main-content is-transparent">
        <div class="hero">
            <div class="hero-body">
                <h1
                    class="title is-2 is-uppercase has-text-primary has-text-weight-bold"
                >
                    {{ $t("refunds.title") }}
                </h1>
                <p><strong>Ultimo aggiornamento 01 luglio 2023</strong></p>
                <p><strong>RIMBORSI</strong></p>
                <p>
                    Tutte le vendite sono definitive e non verrà emesso alcun
                    rimborso per gli acquisti effettuati sul sito o tramite app.
                </p>
                <p><strong>DOMANDE</strong></p>
                <p>
                    Se hai domande riguardanti la nostra politica di reso e
                    rimborso, contattaci a:
                </p>
                <p>amm.nuovorinascimentoitaliano@gmail.com</p>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
.hero {
    > * {
        color: var(--color-subtle) !important;
    }
}
.hero-body {
    @media screen and (max-width: 768px) {
        max-width: 95vw;
    }
    // padding: 0 1rem;
}
p > strong,
li > strong {
    color: var(--color-primary-alt);
    font-weight: 700;
    font-size: 1.2rem;
}
p {
    margin-bottom: 1rem;
}
p > strong {
    display: block;
}
table {
    word-break: break-word;

    border-collapse: collapse;
    border-spacing: 0;
    margin-bottom: 1rem;
    width: 100%;
    border: 1px solid var(--color-primary-alt);
    th,
    td {
        strong {
            color: var(--color-primary-alt);
            font-weight: 700;
            text-transform: uppercase;
        }
        // first child
        &:first-child {
            width: 10rem;
        }
        text-align: left;
        padding: 0.5rem;
        border: 1px solid var(--color-primary-alt);
    }
    th {
        background-color: var(--bg-secondary);
        color: var(--color-subtle);
    }
    tr:nth-child(even) {
        background-color: var(--bg-secondary);
        color: var(--color-subtle);
    }
    tr:nth-child(odd) {
        background-color: var(--bg-secondary);
        color: var(--color-subtle);
    }
}
a {
    color: var(--color-primary) !important;
    // text-decoration: underline;
    text-transform: uppercase;
    font-weight: 700;
    margin: 0 0.25rem;
    display: inline !important;
}

// list styling

ul {
    list-style: none;
    padding-left: 0;
    margin-left: 0;
    // margin-bottom: 1rem;
    li {
        margin-left: 0;
        margin-bottom: 1rem;
        &:before {
            content: "•";
            color: var(--color-primary-alt);
            display: inline-block;
            width: 1rem;
            margin-left: 1rem;
        }
    }
}
</style>
<script>
export default {
    name: "Refunds",
    data() {
        return {
            pageTitle: "TDF*P — " + this.$t("refunds.meta.title"),
            height: "100%",
        };
    },
    layout: "default",

    mounted() {
        this.$store.commit("setCurrPageTitle", this.$t("refunds.title"));
        if (this.$i18n.locale === "en") {
            //redirecet to privacy-en
            this.$router.push("/en/refunds-en");
        }
        this.enterAnimation();
        // load termly embed script
    },
    head() {
        return {
            title: this.pageTitle,
        };
    },
    watch: {
        $route(to, from) {
            this.$store.commit("setCurrPageTitle", this.$t("refunds.title"));
        },
    },

    methods: {
        enterAnimation() {
            const anime = this.$anime;
            anime({
                targets: ".main-content",
                easing: "easeInOutQuad",
                opacity: [0, 1],
                filter: ["blur(2rem)", "blur(0px)"],
                duration: 360,
            });
        },
    },
    beforeMount() {
        window.addEventListener("scroll", this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
    },
};
</script>
